import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Input, Select, SelectProps } from '@robocorp/components';
import { styled } from '@robocorp/theme';
import { ApiHelperContextType } from '../context';

const Container = styled(Box)`
  label span {
    text-transform: initial;

    &::first-letter {
      text-transform: capitalize;
    }
  }
`;

interface SelectInputProps {
  description?: string;
  required?: boolean;
  loading?: boolean;
  in?: string;
}

export interface ApiHelperSelectInputWrapperProps extends SelectInputProps {
  pathParameters: ApiHelperContextType['pathParameters'];
  value: ApiHelperContextType['pathParameters'][keyof ApiHelperContextType['pathParameters']];
  setValue: ApiHelperContextType['setPathParameter'];
  setValues: ApiHelperContextType['setPathParameters'];
}

export const ApiHelperSelectInput: FC<SelectProps & SelectInputProps> = ({
  items,
  label,
  description,
  value,
  placeholder,
  readOnly,
  disabled,
  onChange,
  noItemsFound,
  loading = false,
  required = false,
  in: type = 'path',
  ...props
}) => {
  const { t } = useTranslation();

  const canSelectFirstItem = !loading && items.length > 0 && !value;
  useEffect(() => {
    if (canSelectFirstItem && (type === 'path' || required)) {
      onChange?.(items[0].value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canSelectFirstItem]);

  return (
    <Container mb="$16">
      {loading || items.length > 0 ? (
        <Select
          items={items}
          label={label}
          value={value}
          placeholder={loading ? t('loading') : `${t('choose')}...`}
          onChange={onChange}
          readOnly={readOnly}
          disabled={loading || disabled}
          {...props}
        />
      ) : (
        <Input
          label={description ?? label}
          value={value}
          onChange={(event) => onChange?.(event.target.value)}
          placeholder={placeholder ?? noItemsFound ?? t('noItemsFound')}
          readOnly={readOnly}
          error={required && type === 'query' && value === ''}
        />
      )}
    </Container>
  );
};
